import React from 'react'
import { bool, string } from 'prop-types'
import { useSelector } from 'react-redux'
import { selectLabels } from '../../../redux/configuration/selectors'
import { ENABLE_ACCOMMODATIONS } from '../../../configuration/constants'
import {
  selectDepartureRoute,
  selectIsCommercial
} from '../../../redux/ferryRouteSelections/selectors'
import ConfigConsumer from '../../../redux/configuration/context'

// STYLES
import './ResourceAvailability.scss'
import SvgIcon from '../../SvgIcon/SvgIcon'

const ResourceAvailability = ({
  vehiclesAvailable,
  accommodationsAvailable,
  isFlex,
  shipName,
  petExteriorAvailable,
  passengerAvailability,
  activeVehicleResourceCode
}) => {
  const departureRoute = useSelector(selectDepartureRoute)
  const labels = useSelector(selectLabels)
  const isCommercial = useSelector(selectIsCommercial)
  const getVehicleSpaceLabel = () => {
    const words = labels.availableVehicleSpace.split(' ')
    if (isCommercial && words.length >= 3) {
      words.splice(1, 0, labels.commercial)
    }
    return words.join(' ')
  }
  const getNoVehicleSpaceLabel = () => {
    const words = labels.noAvailableVehicleSpace.split(' ')
    if (isCommercial && words.length >= 4) {
      words.splice(1, 0, labels.commercial)
    }
    return words.join(' ')
  }
  return (
    <ConfigConsumer>
      {({ themeVariables }) => (
        <div
          className={`crossing-card-resource-availability ${
            isFlex ? 'flex' : ''
          }`}
        >
          <div className={`resources`}>
            {departureRoute.ferryId === 'nfl' && shipName && (
              <div className="detail accommodations">
                <SvgIcon
                  type="ship"
                  fill={themeVariables.themeIconColor}
                  className="crossing-card-resource-icon"
                  width="36"
                  viewBox="0 0 36 34"
                  height="34"
                />
                <p>
                  {shipName.indexOf('MV') === -1 ? `MV ${shipName}` : shipName}
                </p>
              </div>
            )}
            {activeVehicleResourceCode &&
              (vehiclesAvailable ? (
                <div className="detail accommodations">
                  <SvgIcon
                    type={isCommercial ? 'commercial-vehicle' : 'vehicle'}
                    fill={themeVariables.themeIconColor}
                    className="crossing-card-resource-icon"
                    width="36"
                    viewBox={isCommercial ? '0 0 22 28' : '0 0 18 16'}
                    height="32"
                  />
                  <p>{getVehicleSpaceLabel()}</p>
                </div>
              ) : (
                <div className="detail accommodations">
                  <SvgIcon
                    type={isCommercial ? 'no-commercial-vehicle' : 'no-vehicle'}
                    fill={themeVariables.themeDisabledIconColor}
                    className="crossing-card-resource-icon"
                    width="36"
                    viewBox={isCommercial ? '0 0 22 28' : '0 0 535 541'}
                    height="36"
                  />
                  <p>{getNoVehicleSpaceLabel()}</p>
                </div>
              ))}
            {
              <div className="detail accommodations">
                <SvgIcon
                  type="passenger-availability"
                  fill={
                    passengerAvailability
                      ? themeVariables.themeIconColor
                      : themeVariables.themeDisabledIconColor
                  }
                  className="crossing-card-resource-icon"
                  width="36"
                  viewBox="0 0 24 24"
                  height="36"
                />
                <p>
                  {passengerAvailability
                    ? 'Available Walk-on Space'
                    : 'No Walk-on Space Available'}
                </p>
              </div>
            }
            {(departureRoute.ferryId === 'nfl' ||
              departureRoute.ferryId === 'bfl') &&
              !isCommercial &&
              accommodationsAvailable && (
                <div className="detail accommodations">
                  <SvgIcon
                    type="extras"
                    fill={themeVariables.themeIconColor}
                    className="crossing-card-resource-icon"
                    width="36"
                    viewBox="0 0 24 24"
                    height="36"
                  />
                  <p>{labels.availableKennels || 'Available Kennels'}</p>
                </div>
              )}
            {departureRoute.ferryId === 'bfl' &&
              petExteriorAvailable &&
              process.env.REACT_APP_ENABLE_BFL_PET_EXTERIOR === 'true' && (
                <div className="detail accommodations">
                  <SvgIcon
                    type="extras"
                    fill={themeVariables.themeIconColor}
                    className="crossing-card-resource-icon"
                    width="36"
                    viewBox="0 0 24 24"
                    height="36"
                  />
                  <p>{'Available Pet Exterior'}</p>
                </div>
              )}
            {(departureRoute.ferryId === 'nfl' ||
              departureRoute.ferryId === 'bfl') &&
              ENABLE_ACCOMMODATIONS &&
              !accommodationsAvailable &&
              !isCommercial && (
                <div className="detail accommodations">
                  <SvgIcon
                    type="extras"
                    fill={themeVariables.themeDisabledIconColor}
                    className="crossing-card-resource-icon"
                    width="36"
                    viewBox="0 0 24 24"
                    height="36"
                  />
                  <p>{labels.noAvailableKennels || 'No Available Kennels'}</p>
                </div>
              )}
          </div>
        </div>
      )}
    </ConfigConsumer>
  )
}

ResourceAvailability.propTypes = {
  vehiclesAvailable: bool,
  accommodationsAvailable: bool,
  isFlex: bool,
  petExteriorAvailable: bool,
  passengerAvailability: bool,
  activeVehicleResourceCode: string
}

export default ResourceAvailability
